import { render } from "./Favorites.vue?vue&type=template&id=a866e048&scoped=true"
import script from "./Favorites.vue?vue&type=script&lang=js"
export * from "./Favorites.vue?vue&type=script&lang=js"

import "./Favorites.vue?vue&type=style&index=0&id=a866e048&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a866e048"]])

export default __exports__